// Storage keys - centralized and consistent
export const AUTH_STORAGE_KEYS = {
  SUPABASE_AUTH: 'nexus-booking-auth',
  SESSION_BACKUP: 'nexus-session-backup', 
  PWA_AUTH_CHECK: 'nexus-pwa-auth-check',
  BUSINESS_CACHE: 'nexus-business-cache',
  USER_PREFERENCES: 'nexus-user-prefs'
} as const;

// Configuration constants
export const AUTH_CONFIG = {
  // Token timing
  JWT_EXPIRY_BUFFER: 5 * 60 * 1000, // 5 minutes
  REFRESH_TOKEN_BUFFER: 60 * 60 * 1000, // 1 hour
  SESSION_CHECK_INTERVAL: 30 * 1000, // 30 seconds
  
  // PWA vs Browser
  PWA_REFRESH_INTERVAL: 5 * 60 * 1000, // 5 minutes
  BROWSER_REFRESH_INTERVAL: 10 * 60 * 1000, // 10 minutes
  
  // Retry configuration
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY_BASE: 1000,
  RETRY_BACKOFF_FACTOR: 2,
  
  // Storage
  STORAGE_RETRY_ATTEMPTS: 3,
  STORAGE_OPERATION_TIMEOUT: 5000
} as const;

// Auth events for cross-component communication
export const AUTH_EVENTS = {
  SESSION_RESTORED: 'auth:session-restored',
  SESSION_EXPIRED: 'auth:session-expired', 
  LOGOUT_INITIATED: 'auth:logout-initiated',
  LOGOUT_COMPLETED: 'auth:logout-completed',
  TOKEN_REFRESHED: 'auth:token-refreshed',
  STORAGE_CLEARED: 'auth:storage-cleared'
} as const;
